import { Schema, ParseResult } from "effect";
import { searchParamsToNestedObject, objectToSearchParams } from "./utils";

export const parseSearchParams = <A, I, R>(schema: Schema.Schema<A, I, R>) =>
  Schema.compose(
    Schema.transformOrFail(Schema.instanceOf(URLSearchParams), Schema.Any, {
      strict: true,
      decode: (i, _, ast) =>
        ParseResult.try({
          try: () => searchParamsToNestedObject(i),
          catch: (e) =>
            new ParseResult.Type(
              ast,
              i,
              e instanceof Error ? e.message : String(e),
            ),
        }),
      encode: (a, _, ast) =>
        ParseResult.try({
          try: () => objectToSearchParams(a),
          catch: (e) =>
            new ParseResult.Type(
              ast,
              a,
              e instanceof Error ? e.message : String(e),
            ),
        }),
    }),
    schema,
  );
